<template>
  <div v-if="displayFeature" class="question-verification pl-3">
    <div class="form-group pt-1 pb-1 no-gutters verification-control">
      <div class="verification-domain-row">
        <input
          type="checkbox"
          :id="'emailDomainVerificationEnabled_' + inputId"
          name="emailDomainVerificationEnabled"
          v-model="emailDomainVerificationEnabled"
          @click="checkEmailDomainVerificationEnabled($event)"
        />
        <label :for="'emailDomainVerificationEnabled_' + inputId" class="control-label pl-1 pr-2">Verification</label>
        <span class="verification-at-symbol pr-2">@</span>
        <div class="verification-domain-field">
          <textarea
            v-model="emailDomainVerificationList"
            :id="'emailDomainVerificationList_' + inputId"
            name="emailDomainVerificationList"
            rows="1"
            class="form-control form-control-sm verification-domain-list"
            :disabled="!isEmailDomainVerificationEnabled"
            @input="saveVerification"
          ></textarea>
          <span class="verification-domain-help">[Please separate domain with semi-colons]</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionVerification",
  props: {
    initialEmailDomainVerificationEnabled: {
      type: [Boolean, String],
      default: false
    },
    initialEmailDomainVerificationList: {
      type: String,
      default: ""
    },
    displayFeature: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      emailDomainVerificationEnabled: false,
      emailDomainVerificationList: ""
    };
  },
  computed: {
    isEmailDomainVerificationEnabled: function() {
      return this.normalizeEnabled(this.emailDomainVerificationEnabled);
    }
  },
  watch: {
    initialEmailDomainVerificationEnabled: function() {
      this.emailDomainVerificationEnabled = this.normalizeEnabled(this.initialEmailDomainVerificationEnabled);
    },
    initialEmailDomainVerificationList: function() {
      this.emailDomainVerificationList = this.initialEmailDomainVerificationList || "";
    }
  },
  methods: {
    normalizeEnabled: function(value) {
      return value === true || value == "true" || value == "Y";
    },
    checkEmailDomainVerificationEnabled: function(event) {
      this.emailDomainVerificationEnabled = event.target.checked;
      this.saveVerification();
    },
    saveVerification: function() {
      this.$emit("save", this.normalizeEnabled(this.emailDomainVerificationEnabled), this.emailDomainVerificationList);
    }
  },
  mounted() {
    this.emailDomainVerificationEnabled = this.normalizeEnabled(this.initialEmailDomainVerificationEnabled);
    this.emailDomainVerificationList = this.initialEmailDomainVerificationList || "";
  }
};
</script>
